import React, { forwardRef, useRef, useState } from "react";
import html2pdf from "html2pdf.js";
import { Box, Grid, List, ListItem, Stack } from "@mui/material";
import { SwiperSlide } from "swiper/react";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { PhysicalOnePagerResultStyle } from "./PhysicalOnePagerResultStyle";
import VSNTypography from "../../../shared/VSNTypography";
import VSNImage from "../../../shared/VSNImage";
import VSNLoader from "../../../shared/VSNLoader";
import VSNBreadcrumbs from "../../../shared/VSNBreadcrumbs";
import SwiperCardComponent from "../../assessment/SwiperCardComponent";
import humanBody from "../../../assets/assesments/physical/physical/humanBody.png";
import { VSNSwiper } from "../../../shared/VSNSwiper";
import { BulletIcon, PurpalFlowerBullet, StarIcon } from "../../../shared/icon";
import VSNButton from "../../../shared/VSNButton";
import {
  arrayOfMockData,
  keyInsights,
  peplanSwiperData,
} from "./CPETDashboard/AssessmentConstant";
import MRFResultContainer from "../../../container/MRF.container";
import {
  PDFHeader,
  PDFRecommendationSection,
} from "./PhysicalDashboardPDFCommonComponent";

const PrintComponent = forwardRef((props, ref) => {
  const { result, header } = props;
  const classes = PhysicalOnePagerResultStyle();

  return (
    <Box sx={{ visibility: "hidden", height: 0, overflow: "hidden" }}>
      <Box ref={ref}>
        <Stack
          gap={2}
          sx={{
            pageBreakAfter: "always",
          }}
        >
          <PDFHeader
            title="Physical Exam Results and Next Steps"
            header={header}
          />

          <Stack
            className={classes.assessmentReportCard}
            sx={{
              background: "#FAF6F0 !important",
            }}
          >
            <VSNTypography
              variant="h3"
              component="h3"
              className={classes.mdHeadingprimary}
              mb={1}
              sx={{
                fontSize: "16px !important",
                color: "#B29263 !important",
                "&:before": { background: "#B29263 !important" },
              }}
            >
              {result?.your_physical_examination_card?.title ?? ""}
            </VSNTypography>

            <Stack gap={1}>
              <Stack direction="row">
                <Box sx={{ height: 12, width: 12 }} mr={2} mt={0.5}>
                  <StarIcon />
                </Box>
                <VSNTypography
                  sx={{
                    fontSize: "14px !important",
                    fontWeight: 500,
                    color: "#0A0A0B",
                    lineHeight: "24px",
                  }}
                >
                  {result?.your_physical_examination_card?.phrase ?? ""}
                </VSNTypography>
              </Stack>
            </Stack>
          </Stack>

          <Stack
            className={classes.assessmentReportCard}
            sx={{
              background: "#FAF6F0 !important",
            }}
            mt={2}
          >
            <VSNTypography
              variant="h3"
              component="h3"
              className={classes.mdHeadingprimary}
              mb={1}
              sx={{
                fontSize: "16px !important",
                color: "#B29263 !important",
                "&:before": { background: "#B29263 !important" },
              }}
            >
              {result?.vasana_insights_on_physical_examination?.title ?? ""}
            </VSNTypography>
            <VSNTypography component="p" className={classes.desc}>
              {result?.vasana_insights_on_physical_examination?.description ??
                ""}
            </VSNTypography>

            <Stack gap={1} pt={1}>
              {result?.vasana_insights_on_physical_examination?.questions?.map(
                (el, index) => (
                  <Stack direction="row" key={index}>
                    <Box mr={2} mt={0.6}>
                      <PurpalFlowerBullet height="14" width="14" />
                    </Box>
                    <VSNTypography
                      sx={{
                        fontSize: "14px !important",
                        fontWeight: 500,
                        color: "#0A0A0B",
                        lineHeight: "24px",
                      }}
                    >
                      <span style={{ color: "#86650A", fontWeight: 500 }}>
                        {el?.question ?? ""}{" "}
                      </span>
                      <br />
                      {el?.answer}
                    </VSNTypography>
                  </Stack>
                )
              )}
            </Stack>
          </Stack>
        </Stack>

        <Stack
          className={classes.assessmentReportCard}
          sx={{
            background: "#FAF6F0 !important",
            pageBreakAfter: "always",
          }}
          gap={1}
        >
          <VSNTypography
            variant="h3"
            component="h3"
            className={classes.mdHeadingprimary}
            sx={{
              fontSize: "16px !important",
              color: "#B29263 !important",
              "&:before": { background: "#B29263 !important" },
            }}
          >
            {result?.physicians_findings_and_next_steps_for_your_health
              ?.title ?? ""}
          </VSNTypography>

          <Box display="flex">
            <Box sx={{ height: 12, width: 12 }} pr={3}>
              <BulletIcon />
            </Box>
            <VSNTypography
              sx={{
                fontSize: "15px",
                fontWeight: 500,
                color: "#3A3A40",
                lineHeight: "24px",
              }}
              dangerouslySetInnerHTML={{
                __html:
                  result?.physicians_findings_and_next_steps_for_your_health
                    ?.plan,
              }}
            />
          </Box>

          <Box>
            {result?.physicians_findings_and_next_steps_for_your_health?.recommended_referrals?.referrals?.some(
              (el) => el?.is_checked
            ) ? (
              <Box>
                <VSNTypography
                  variant="h3"
                  component="h3"
                  sx={{ fontSize: 16, fontWeight: 700 }}
                  my={1}
                  color="var(--blackGray)"
                >
                  Recommended Referrals
                </VSNTypography>
                <Box sx={{ display: "flex", flexWrap: "wrap" }} gap={1}>
                  {result?.physicians_findings_and_next_steps_for_your_health?.recommended_referrals?.referrals?.map(
                    (el, index) => {
                      if (el?.is_checked) {
                        const { color, backGround } = keyInsights[index % 4];
                        return (
                          <Box
                            // className={classes.notesListTab}
                            sx={{
                              width: "fit-content",
                              backgroundColor: `${backGround}`,
                              border: `1px solid ${color}`,
                              padding: "4px 8px",
                              borderRadius: 2,
                            }}
                            key={index}
                          >
                            <VSNTypography
                              component="p"
                              fontSize="16px"
                              fontWeight={500}
                              color={color}
                            >
                              {el?.title}
                            </VSNTypography>
                          </Box>
                        );
                      }
                      return null;
                    }
                  )}
                </Box>
              </Box>
            ) : (
              <VSNTypography
                variant="h3"
                component="h3"
                sx={{ fontSize: 16, fontWeight: 700 }}
                my={1}
                color="var(--blackGray)"
              >
                No Recommended Referrals
              </VSNTypography>
            )}
          </Box>
        </Stack>

        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.assessmentReportCard}
          sx={{
            background: "#FAF6F0 !important",
            pageBreakAfter: "always",
          }}
        >
          <Stack flex={1}>
            <Box className={classes.diagnosticInputs}>
              <List>
                {result?.body_notes_card?.body_notes?.map(
                  ({ icon, note, title }, index) => {
                    const matchedData = arrayOfMockData?.find(
                      (item) => item.staticTitle === title
                    );
                    if (index % 2 === 0) {
                      return (
                        <ListItem key={index} sx={{ paddingBottom: "20px" }}>
                          <VSNTypography textAlign="right">
                            {title}
                            <br />
                            <span>{note}</span>
                          </VSNTypography>
                          <Stack>
                            <Box
                              sx={{
                                width: "80px",
                                height: "80px",
                                border: "2px solid #8B3F9E",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <VSNImage
                                src={matchedData.staticIcon}
                                alt="icon"
                              />
                            </Box>
                          </Stack>
                        </ListItem>
                      );
                    }
                    return null;
                  }
                )}
              </List>
            </Box>
          </Stack>

          <Stack height="400px">
            <Stack justifyContent="center">
              <Box display="flex" justifyContent="center">
                <VSNImage src={humanBody} alt="shape" />
              </Box>
            </Stack>
          </Stack>

          <Stack flex={1}>
            <Box className={classes.diagnosticInputs}>
              <List>
                {result?.body_notes_card?.body_notes?.map(
                  ({ icon, note, title }, index) => {
                    const matchedData = arrayOfMockData?.find(
                      (item) => item.staticTitle === title
                    );

                    if (index % 2 !== 0) {
                      return (
                        <ListItem key={index} sx={{ paddingBottom: "20px" }}>
                          <Stack>
                            <Box
                              sx={{
                                width: "80px",
                                height: "80px",
                                border: "2px solid #8B3F9E",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <VSNImage
                                src={matchedData.staticIcon}
                                alt="icon"
                              />
                            </Box>
                          </Stack>
                          <VSNTypography textAlign="left">
                            {title}
                            <br />
                            <span>{note}</span>
                          </VSNTypography>
                        </ListItem>
                      );
                    }
                    return null;
                  }
                )}
              </List>
            </Box>
          </Stack>
        </Stack>

        <PDFRecommendationSection
          data={result?.recommendation_for_better_health ?? {}}
          staticData={peplanSwiperData ?? []}
        />
      </Box>
    </Box>
  );
});

export default function PhysicalExaminationResult({
  endPointToCall,
  showBreadCrumbs = true,
  breadCrumbAndButton,
  releaseButton,
  assessmentUserInfo,
  viewAllResult,
  from,
}) {
  const classes = PhysicalOnePagerResultStyle();
  const {
    AssessmentResult: containerResult,
    loader,
    currentAssessment,
  } = from === "viewAll" ? {} : MRFResultContainer({ endPointToCall });

  const AssessmentResult = from === "viewAll" ? viewAllResult : containerResult;

  const [loading, setLoading] = useState(false);

  const printRef = useRef();

  const breadcrumbsRoutes = [
    {
      path: "/assessments",
      label: "Assessments",
    },
    {
      path: `/assessments/${currentAssessment?.assessment_id}`,
      label: `Physical Examination and Provider Plan`,
    },
  ];

  const handleDownloadPDF = () => {
    setLoading(true);
    const element = printRef.current;

    const adminFilename = `${assessmentUserInfo?.name}_${assessmentUserInfo?.assessment_name}.pdf`;
    const userFilename = `${AssessmentResult?.info?.name}_${currentAssessment?.assessment_name}.pdf`;
    const fileName = assessmentUserInfo ? adminFilename : userFilename;

    const options = {
      margin: 6,
      filename: fileName,
      image: { type: "jpeg", quality: 0.7 },
      html2canvas: { scale: 1.7, useCORS: true, allowTaint: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };

    html2pdf()
      .from(element)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        pdf.save(fileName);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const PDFDetails = assessmentUserInfo ?? AssessmentResult?.info;

  if (from !== "viewAll" && (loader?.assessmentResult || !AssessmentResult)) {
    return <VSNLoader variant="fullPage" />;
  }

  return (
    <div className={classes.mainLayout}>
      {from !== "viewAll" ? (
        showBreadCrumbs ? (
          <Box mt={2.5} mb={1.8}>
            <VSNBreadcrumbs {...{ breadcrumbsRoutes }} />
          </Box>
        ) : (
          <Box className={classes.headingButton}>
            <Box>{breadCrumbAndButton}</Box>
            <Stack
              direction="row"
              gap={{ sm: 2, xs: 1 }}
              alignItems="center"
              flexWrap="wrap"
              sx={{ width: { xsm: "auto", xs: "100%" } }}
            >
              <VSNButton
                className={classes.PrintButton}
                handleClick={handleDownloadPDF}
                isLoading={loading}
              >
                <Stack direction="row" alignItems="center" gap={1}>
                  <PrintOutlinedIcon />
                  Print Physical Examination
                </Stack>
              </VSNButton>
              {AssessmentResult?.is_locked ? releaseButton : ""}
            </Stack>
          </Box>
        )
      ) : null}

      {AssessmentResult?.message === "No report found" ? (
        <Stack direction="row" justifyContent="center" p={5}>
          <VSNTypography variant="h5">No Report Found</VSNTypography>
        </Stack>
      ) : (
        <>
          {showBreadCrumbs && (
            <Stack
              direction={{ xsm: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <VSNTypography
                fontSize={{ xsm: 24, sm: 34 }}
                sx={{ fontWeight: 700 }}
              >
                {AssessmentResult?.title ?? ""}
              </VSNTypography>
              <VSNButton
                className={classes.PrintButton}
                handleClick={handleDownloadPDF}
                isLoading={loading}
              >
                <Stack direction="row" alignItems="center" gap={1}>
                  <PrintOutlinedIcon />
                  Print Physical Examination Report
                </Stack>
              </VSNButton>
            </Stack>
          )}

          <PrintComponent
            ref={printRef}
            result={AssessmentResult}
            header={PDFDetails}
          />

          <Box sx={{ marginBottom: "24px" }}>
            <Stack className={classes.assessmentReportCard}>
              <Box sx={{ display: "block" }}>
                <VSNTypography className={classes.mdHeadingMain}>
                  {AssessmentResult?.your_physical_examination_card?.title ??
                    ""}
                </VSNTypography>
              </Box>

              <Stack direction={{ md: "row" }} mt={1} spacing={2}>
                <Box flex={1}>
                  <VSNTypography component="p" className={classes.desc}>
                    {AssessmentResult?.your_physical_examination_card?.phrase ??
                      ""}
                  </VSNTypography>
                </Box>
              </Stack>
            </Stack>
          </Box>
          <Grid
            container
            spacing={3}
            mb={3}
            sx={{
              flexDirection: { sm: "row", xs: "column-reverse" },
            }}
          >
            <Grid item xl={6} lg={12} xs={12}>
              <Stack spacing={3}>
                <Box>
                  <Stack className={classes.assessmentReportCard}>
                    <VSNTypography
                      variant="h3"
                      component="h3"
                      className={classes.mdHeadingprimary}
                      mb={1}
                    >
                      {AssessmentResult
                        ?.physicians_findings_and_next_steps_for_your_health
                        ?.title ?? ""}
                    </VSNTypography>
                    <Box py={1} display="flex">
                      <Box pr={2} width="12px">
                        {/* <BulletIcon /> */}
                        <VSNImage
                          src={
                            AssessmentResult
                              ?.physicians_findings_and_next_steps_for_your_health
                              ?.icon
                          }
                          alt="listicon"
                        />
                      </Box>
                      <VSNTypography
                        sx={{
                          fontSize: "15px",
                          fontWeight: 500,
                          color: "#3A3A40",
                          lineHeight: "24px",
                        }}
                        dangerouslySetInnerHTML={{
                          __html:
                            AssessmentResult
                              ?.physicians_findings_and_next_steps_for_your_health
                              ?.plan,
                        }}
                      />
                    </Box>

                    <Box>
                      {AssessmentResult?.physicians_findings_and_next_steps_for_your_health?.recommended_referrals?.referrals?.some(
                        (el) => el?.is_checked
                      ) ? (
                        <Box>
                          <VSNTypography
                            variant="h3"
                            component="h3"
                            sx={{ fontSize: 16, fontWeight: 700 }}
                            my={1}
                            mt={3}
                            color="var(--blackGray)"
                          >
                            Recommended Referrals
                          </VSNTypography>
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap" }}
                            gap={2}
                          >
                            {AssessmentResult?.physicians_findings_and_next_steps_for_your_health?.recommended_referrals?.referrals?.map(
                              (el, index) => {
                                if (el?.is_checked) {
                                  const { color, backGround } =
                                    keyInsights[index % 4];

                                  return (
                                    <Box
                                      className={classes.notesListTab}
                                      sx={{
                                        width: "fit-content",
                                        backgroundColor: backGround,
                                        border: `1px solid ${color}`,
                                      }}
                                      key={index}
                                    >
                                      <VSNTypography
                                        component="p"
                                        color={color}
                                      >
                                        {el?.title}
                                      </VSNTypography>
                                    </Box>
                                  );
                                }
                                return null;
                              }
                            )}
                          </Box>
                        </Box>
                      ) : (
                        <VSNTypography
                          variant="h3"
                          component="h3"
                          sx={{ fontSize: 16, fontWeight: 700 }}
                          my={1}
                          mt={3}
                          color="var(--blackGray)"
                        >
                          No Recommended Referrals
                        </VSNTypography>
                      )}
                    </Box>
                  </Stack>
                </Box>
                <Box>
                  <Stack className={classes.assessmentReportCardWhite}>
                    <VSNTypography
                      variant="h3"
                      component="h3"
                      className={classes.mdHeading}
                      mb={1}
                    >
                      {AssessmentResult?.vasana_insights_on_physical_examination
                        ?.title ?? ""}
                    </VSNTypography>
                    <VSNTypography component="p" className={classes.desc}>
                      {AssessmentResult?.vasana_insights_on_physical_examination
                        ?.description ?? ""}
                    </VSNTypography>
                    <List className={classes.dailyFunctioning}>
                      {AssessmentResult?.vasana_insights_on_physical_examination?.questions?.map(
                        (el, index) => (
                          <ListItem key={index}>
                            <Box mt={0.5}>
                              {/* <PurpalFlowerBullet /> */}
                              <VSNImage src={el?.icon} alt="listicon" />
                            </Box>
                            <VSNTypography color="var(--blackGray)">
                              <span
                                style={{ color: "#86650A", fontWeight: 500 }}
                              >
                                {el?.question ?? ""}{" "}
                              </span>
                              <br />
                              {el?.answer}
                            </VSNTypography>
                          </ListItem>
                        )
                      )}
                    </List>
                  </Stack>
                </Box>
              </Stack>
            </Grid>
            <Grid item xl={6} lg={12} xs={12}>
              <Stack
                direction={{ sm: "column", md: "row" }}
                justifyContent={{ md: "center", sm: "space-between" }}
                className={classes.assessmentReportCard}
              >
                <Stack flex={1} sx={{ display: { md: "block", xs: "none" } }}>
                  <Box className={classes.diagnosticInputs}>
                    <List>
                      {AssessmentResult?.body_notes_card?.body_notes?.map(
                        ({ icon, note, title }, index) => {
                          if (index % 2 === 0) {
                            return (
                              <ListItem key={index}>
                                <VSNTypography textAlign="right">
                                  {title}
                                  <br />
                                  <span>{note}</span>
                                </VSNTypography>
                                <Stack>
                                  <Box
                                    sx={{
                                      width: {
                                        xlg: "80px",
                                        lg: "60px",
                                        md: "80px",
                                      },
                                      height: {
                                        xlg: "80px",
                                        lg: "60px",
                                        md: "80px",
                                      },
                                      // border: "2px solid #8B3F9E",
                                      borderRadius: "50%",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <VSNImage src={icon} alt="icon" />
                                  </Box>
                                </Stack>
                              </ListItem>
                            );
                          }
                          return null;
                        }
                      )}
                    </List>
                  </Box>
                </Stack>

                <Stack>
                  <Stack height="100%" justifyContent="center">
                    <Box display="flex" justifyContent="center">
                      <VSNImage
                        src={AssessmentResult?.body_notes_card?.body_img}
                        alt="shape"
                      />
                    </Box>
                  </Stack>
                </Stack>

                <Stack flex={1} sx={{ display: { md: "block", xs: "none" } }}>
                  <Box className={classes.diagnosticInputs}>
                    <List>
                      {AssessmentResult?.body_notes_card?.body_notes?.map(
                        ({ icon, note, title }, index) => {
                          if (index % 2 !== 0) {
                            return (
                              <ListItem key={index}>
                                <Stack>
                                  <Box
                                    sx={{
                                      width: {
                                        xlg: "80px",
                                        lg: "60px",
                                        md: "80px",
                                      },
                                      height: {
                                        xlg: "80px",
                                        lg: "60px",
                                        md: "80px",
                                      },
                                      // border: "2px solid #8B3F9E",
                                      borderRadius: "50%",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <VSNImage src={icon} alt="icon" />
                                  </Box>
                                </Stack>
                                <VSNTypography textAlign="left">
                                  {title}
                                  <br />
                                  <span>{note}</span>
                                </VSNTypography>
                              </ListItem>
                            );
                          }
                          return null;
                        }
                      )}
                    </List>
                  </Box>
                </Stack>

                <Box
                  sx={{
                    padding: "20px",
                    display: { md: "none", xs: "block" },
                  }}
                  position="relative"
                  mt={2}
                >
                  <Stack
                    direction="row"
                    spacing={1.4}
                    className={classes.customArrow}
                  >
                    <div className="swiper-button image-swiper-button-next" />
                    <div className="swiper-button image-swiper-button-prev" />
                  </Stack>
                  <VSNSwiper
                    className={classes.containerCard}
                    navigation={{
                      prevEl: ".image-swiper-button-next",
                      nextEl: ".image-swiper-button-prev",
                      disabledClass: "swiper-button-disabled",
                    }}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                      },
                    }}
                  >
                    {AssessmentResult?.body_notes_card?.body_notes?.map(
                      ({ icon, note, title }, index) => (
                        <SwiperSlide key={index}>
                          <Stack direction="row" alignItems="center" gap={2}>
                            <Stack>
                              <Box
                                sx={{
                                  width: "80px",
                                  height: "80px",
                                  // border: "2px solid #8B3F9E",
                                  borderRadius: "50%",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <VSNImage src={icon} alt="icon" />
                              </Box>
                            </Stack>
                            <Stack>
                              <VSNTypography
                                variant="h4"
                                component="h4"
                                fontSize={16}
                                fontWeight={600}
                                lineHeight="20px"
                                color="#5D5D5D"
                                // my={{ xts: 1.3, xs: 1.15 }}
                                minHeight="40px"
                                textAlign="left"
                              >
                                {title}
                              </VSNTypography>
                              <VSNTypography
                                variant="h4"
                                component="h4"
                                fontSize={14}
                                fontWeight={400}
                                lineHeight="18px"
                                color="#707070"
                                margin="0 0 auto"
                                textAlign="left"
                              >
                                {note}
                              </VSNTypography>
                            </Stack>
                          </Stack>
                        </SwiperSlide>
                      )
                    )}
                  </VSNSwiper>
                </Box>
              </Stack>
            </Grid>
          </Grid>

          <SwiperCardComponent
            title={AssessmentResult?.recommendation_for_better_health?.title}
            description={
              AssessmentResult?.recommendation_for_better_health?.description
            }
            data={
              AssessmentResult?.recommendation_for_better_health
                ?.recommendations ?? []
            }
            phyical
          />
        </>
      )}
    </div>
  );
}
